module.exports = __webpack_public_path__ + "img/Large-Bevel-Attachment-13.78506502.png";